import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

export const ArrowUpIcon = (props: SvgIconProps) => (
  <SvgIcon width="10" height="16" viewBox="0 0 10 16" fill="none" {...props}>
    <path d="M4.91239 0.412598L9.82087 7.77538H0.00390625L4.91239 0.412598Z" fill="#5B5B5B" />
    <path d="M6.31895 5.26953H3.50684V15.9814H6.31895V5.26953Z" fill="#5B5B5B" />
  </SvgIcon>
);
